<template>
  <div class="servey">
    <div class="servey_content">
      <div class="nav">
        <div class="nav_type">{{QT}}</div>
        <button v-if="rownumber<questionDataLenght" class="nav_btn" ref="serveyNextClick" @click="nextBtn">下一题</button>
        <button v-if="rownumber>=questionDataLenght" @click.once="testCommit"  ref="proxyClick" class="nav_btn">提交问卷调查</button>
      </div>
      <div class="servey_content_neirong">
        <div class="servey_content_neirong_title">
          <span class="num">{{rownumber}}.&nbsp;</span><span class="title">{{QName}}</span>
        </div>
        <div class="servey_content_neirong_options">
          <div class="content">
            <template v-if="QType === 'radio'">
              <my-radio :radioData="ItemData" :radioName="index" @radioChange="radioChange"></my-radio>
            </template>
           <template v-else-if="QType === 'checkbox'">
              <my-checkbox :checkboxData="ItemData" :checkboxName="index" @checkboxChange="checkboxChange"></my-checkbox>
            </template>
            <template v-else-if="QType === 'textarea'">
              <my-textarea :textareaName="index" @changeTextarea="changeTextarea"></my-textarea>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getJson } from '@/assets/js/httpjson.js'
import { post, fetchUrl } from '@/assets/js/network.js'
import MyRadio from './compoents/MyRadio'
import MyCheckbox from './compoents/MyCheckbox'
import MyTextarea from './compoents/MyTextarea'
import { Toast, MessageBox } from 'mint-ui'
export default {
  name: 'Servey',
  components: {
    MyRadio, MyTextarea, MyCheckbox
  },
  created () {
    this.$nextTick(function () {
      this.loadData()
      this.sinit_question()
    })
  },
  mounted () {
    if (!this.$store.state.loginUser) {
      this.$router.replace('/')
    }
  },
  computed: {
    questionDataLenght () {
      return this.questionData.length
    },
    QName () {
      let idx = this.index
      return this.questionData[idx] ? this.questionData[idx].title : ''
    },
    QType () {
      let idx = this.index
      return this.questionData[idx] ? this.questionData[idx].type : ''
    },
    ItemData () {
      let idx = this.index
      return this.questionData[idx] ? this.questionData[idx].data : []
    },
    QT () {
      let idx = this.index
      let tp = ''
      if (this.questionData.length > 0) {
        if (this.questionData[idx].type === 'radio') {
          tp = '单选题'
        } else if (this.questionData[idx].type === 'checkbox') {
          tp = '多选题'
        } else if (this.questionData[idx].type === 'textarea') {
          tp = '填空题'
        }
      }
      return tp
    }
  },
  data () {
    return {
      index: 0,
      rownumber: 1,
      questionsList: [],
      referenceAnswersList: [],
      questionData: [],
      userAnswers: [],
      next_flag: true,
      commit_flag: false,
      UserPaper: {}
    }
  },
  methods: {
    radioChange (data, name) {
      const question = this.questionData[name]
      for (let item of question.data) {
        item.status = data.value === item.value
        if (item.status && this.index < (this.questionData.length - 1)) {
          this.next_flag = true
        }
        if (this.index >= (this.questionData.length - 1)) {
          this.commit_flag = true
        }
      }
    },
    checkboxChange (data, name, isTextarea) {
      const question = this.questionData[name]
      const index = question.data.findIndex(item => item.value === data.value)
      if (isTextarea) {
        question.data[index].status = true
      } else {
        question.data[index].status = !question.data[index].status
      }
    },
    changeTextarea (data, name) {
      const question = this.questionData[name]
      const textstr = this.trim(data)
      question.data = textstr.length > 0 ? textstr : '无'
      if (question.type === 'textarea') {
        if (this.index >= (this.questionData.length - 1)) {
          this.commit_flag = true
        } else {
          this.next_flag = true
        }
      }
    },
    testCommit () {
      this.next_flag = false
      this.commit_flag = false
      this.insertData(this.index)
      this.srealCommit()
    },
    srealCommit () {
      var _this = this
      post(fetchUrl('/api/newexamination/SubmitPapers'), {'userPaperId': this.UserPaper.userPaperId, 'Questions': this.userAnswers}, function (responseCode, message) {
        if (responseCode === 0 && message.length !== 0) {
          const data = JSON.parse(message)
          if (data.success) {
            _this.userAnswers = []
            _this.$router.replace('/result')
          } else {
            MessageBox.confirm('', {message: '问卷调查提交失败！', title: '错误提示1', cancelButtonText: '返回试卷列表', closeOnClickModal: false, confirmButtonText: '继续提交问卷'})
              .then(function () {
                _this.srealCommit()
              }, function () {
                _this.$router.replace('/list')
              })
          }
        } else {
          Toast('提交考试失败。')
        }
      })
    },
    nextBtn () {
      this.insertData(this.index)
      this.rownumber = this.rownumber + 1
      this.index = this.index + 1
      this.$nextTick(function () {
        this.sinit_question()
      })
    },
    sinit_question () {
      if (this.index >= (this.questionData.length - 1)) {
        this.next_flag = false
        this.commit_flag = true
      }
    },
    insertData (idx) {
      const qSingle = this.questionData[idx]
      if (qSingle.type === 'radio') {
        var radioLength = qSingle.data.length
        var radioFalse = 0
        for (let i = 0; i < qSingle.data.length; i++) {
          if (!(qSingle.data[i].status)) {
            radioFalse = radioFalse + 1
          }
        }
        if (radioLength === radioFalse) {
          this.userAnswers.push({'Paper_ID': qSingle.qPaperId, 'questionsId': qSingle.qId, 'answersNr': ''})
        } else {
          qSingle.data.forEach((item, index) => {
            if (item.status) {
              this.userAnswers.push({'Paper_ID': qSingle.qPaperId, 'questionsId': qSingle.qId, 'answersNr': item.value})
            }
          })
        }
      } else if (qSingle.type === 'checkbox') {
        var checkSingle = []
        qSingle.data.forEach((item, index) => {
          if (item.status) {
            checkSingle.push(item.value)
          }
        })
        this.userAnswers.push({'Paper_ID': qSingle.qPaperId, 'questionsId': qSingle.qId, 'answersNr': checkSingle.sort().join(',')})
      } else if (qSingle.type === 'textarea') {
        let textstr1 = '无'
        if (this.trim(qSingle.data).length > 0) {
          textstr1 = qSingle.data
        }
        this.userAnswers.push({'Paper_ID': qSingle.qPaperId, 'questionsId': qSingle.qId, 'answersNr': textstr1})
      }
    },
    trim (str) { // 删除左右两端的空格
      return str.replace(/(^\s*)|(\s*$)/g, '')
    },
    loadData () {
      var _that = this
      post(fetchUrl('/api/newexamination/getQuestions'), {'paperId': this.$store.state.pr.paperId, 'userId': this.$store.state.user.id}, function (responseCode, message) {
        if (responseCode === 0 && message.length !== 0) {
          const datas = JSON.parse(message)
          if (datas.success && datas.Code === 1) {
            Toast(datas.data)
            _that.$router.replace('/list')
          } else {
            if (datas.success && datas.data.questionsList.length > 0) {
              _that.questionsList = datas.data.questionsList
              _that.referenceAnswersList = datas.data.referenceAnswersList
              _that.UserPaper = datas.data.UserPaper
              _that.convertQuestions()
              _that.questionData.sort(_that.compare('qId'))
            } else {
              Toast('获取考试选项信息失败，请联系管理员。')
              _that.$router.replace('/list')
            }
          }
        } else {
          Toast('提交考试失败。')
        }
      })
    },
    compare (property) {
      return function (a, b) {
        let value1 = a[property]
        let value2 = b[property]
        return value1 - value2
      }
    },
    convertQuestions () {
      var pId = this.$store.state.pr.paperId
      if (this.questionsList.length > 0) {
        this.questionsList.forEach((item, index) => {
          if (pId === item.Paper_ID) {
            var itemType = item.Questions_LX === 1 ? '判断题' : item.Questions_LX === 2 ? '填空题' : item.Questions_LX === 3 ? '单选题' : '多选题'
            var itemOption = item.Questions_LX === 1 ? 'radio' : item.Questions_LX === 2 ? 'textarea' : item.Questions_LX === 3 ? 'radio' : 'checkbox'
            // var question = {id: index + 1, title: item.Questions_NR, type: itemOption, qPaperId: pId, qId: item.Questions_ID, qName: item.Questions_NR, qTypeId: item.Questions_LX, qType: itemType, qFS: item.Questions_FS, qBZTA: item.Questions_BZTA}
            if (this.referenceAnswersList.length > 0) {
              var answers = []
              this.referenceAnswersList.forEach((itemAnswer, index) => {
                if (itemAnswer.Questions_ID === item.Questions_ID && (item.Questions_LX === 1 || item.Questions_LX === 3 || item.Questions_LX === 4)) {
                  var answer = {type: 1, value: itemAnswer.ReferenceAnswers_ID.toString(), label: itemAnswer.ReferenceAnswers_NR, status: false}
                  answers.push(answer)
                } else if (itemAnswer.Questions_ID === item.Questions_ID && (item.Questions_LX === 2)) {
                  answers = ''
                }
              })
            }
            this.questionData.push({id: index + 1, title: item.Questions_NR, type: itemOption, qPaperId: pId, qId: item.Questions_ID, qName: item.Questions_NR, qTypeId: item.Questions_LX, qType: itemType, qFS: item.Questions_FS, qBZTA: item.Questions_BZTA, data: answers})
          }
        })
      }
    }
  }
}
</script>

<style  lang="stylus" scoped>
  .servey
    position: absolute
    width: 100%
    height: 100%
    left: 0
    top: 0
    right: 0
    bottom: 0
    background: #00bcd4
    font-size: .35rem
    .servey_content
      margin-top: .8rem
      margin-bottom: .8rem
      margin-left: .2rem
      margin-right: .2rem
      background-color: white
      border-radius: .07rem
      .nav
        display: flex
        padding: .2rem
        height : .5rem
        align-items: center
        border-bottom: 1px solid #ccc
        .nav_type
          flex: 1
          color: #976e48
          font-weight: bold
          font-size: .4rem
        .nav_btn
          background: #AC2925
          padding-top: .03rem
          padding-bottom: .03rem
          padding-left: .2rem
          padding-right: .2rem
          border-radius: .1rem
          outline: none
          color: white
          font-weight: bold
      .servey_content_neirong
        margin-top: .1rem
        .servey_content_neirong_title
          margin-left : .1rem
          margin-right : .1rem
          font-size: .4rem
          font-weight: bold
          align-items : center
          color : #976e48
          margin-bottom : .3rem
          line-height: .6rem
          text-align : justify
          .num
            font-size: .6rem
            text-align : center
            margin-left : .3rem
        .servey_content_neirong_options
          .content
            padding-bottom : .8rem

</style>



// WEBPACK FOOTER //
// src/servey/Servey.vue